import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { CwsIconConvInfo } from "../vo/cws-icon-conv-info.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetCwsIconConvInfoResponse = {
  MarkCode: string,
  MarkGroupCode: string,
  MarkName: string,
  MarkCodeBranch: string,
  MarkFileUrl: string,
  IconList: {
    IconFileName: string,
    IconUrl: string
  }[]
}[];

/**
 * アイコン情報一覧取得サービス
 * @export GetCwsIconConvInfoService
 * @class GetCwsIconConvInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsIconConvInfoService extends PlessJsonResponderSub<GetCwsIconConvInfoResponse> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsIconConvInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsIconConvInfoService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getCwsIconConvInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsIconConvInfoService
   */
  success(data: GetCwsIconConvInfoResponse) {
    this.model.cwsIconConvInfoList = data.map(_ => new CwsIconConvInfo(
      _.MarkCode,
      _.MarkGroupCode,
      _.MarkName,
      _.MarkCodeBranch,
      _.MarkFileUrl,
      _.IconList.map(m => {
        return {
          iconFileName: m.IconFileName,
          iconUrl: m.IconUrl
        }
      })
    ))
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
